import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/components/site/seo-copy";
import { CategoryPage } from "@/components/site/CategoryPage";
import { categoryBySlug } from "@/components/site/seo";

const category = categoryBySlug("business-development-jobs")!;

export const Route = createFileRoute("/business-development-jobs")({
  head: () => pageHead("/business-development-jobs"),
  component: () => <CategoryPage category={category} />,
});
